import styled from 'styled-components';

export const Description = styled.p`
  margin-bottom: 24px;
`;
